export default {
  attendance: null,
  originalAttendance: null,
  currentStepIndex: 0,
  currentPhaseIndex: 0,
  isLocalSyncedData: true,
  isServerSyncedData: true,
  isSavingData: false,
}
